<template>
  <div class="index-box">
    <div v-for="item in dynamicDetails" :key="item.id">
      <div class="card-list__itemone">
        <div class="active-list__item-location" v-if="item.newsType == 2">
          校友活动
        </div>
        <div class="active-list__item-location-y" v-else>母校新闻</div>
        <div
          class="headDiagram"
          :style="{ backgroundImage: `url(${item.mainImg})` }"
        ></div>
      </div>
      <div class="card-list__title">{{ item.title }}</div>
      <div class="card-list__titledetils">
        <div class="card-list__titledetils-content">
          <div>作者：{{ item.editor }}</div>
          <div>编辑：{{ item.author }}</div>
        </div>
        <div class="card-list__titledetils-content">
          <div>来源：{{ item.source }}</div>
          <div>日期：{{ item.uploadTime }}</div>
        </div>
      </div>
      <div class="card_tail" v-if="fengeList != ''">
        <div v-for="(segment, index) in fengeList" :key="index">
          <div
            v-if="segment.includes('<img')"
            v-html="segment"
            class="card_tail_content"
          ></div>
          <div
            v-else
            v-html="segment"
            class="card_tail_content"
            style="text-indent: 4ch"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
      dynamicDetails: [],
      fengeList: [],
    };
  },
  created() {
    this.getDynamicDetails();
  },
  methods: {
    async getDynamicDetails() {
      const result = await this.$http.get("/amNews/getAmNewsDetail", {
        params: { id: this.id },
      });
      console.log("新闻动态想去", result.data);
      this.dynamicDetails = result.data;

      const sanitizedString = result.data[0].content.replace(
        /<br>|<br\/>/g,
        ""
      );
      const list = sanitizedString
        .split("</p>")
        .map((p) => p.replace("<br/>", ""));
      this.fengeList = list;
      console.log("分割后的数组", this.fengeList);
      // // TODO
      // // 使用split方法根据关键字分割字符串
      // const content = result.data[0].content.split("\n");
      // // 重新组合分段，包含关键字
      // const contentList = [];
      // for (let i = 0; i < content.length; i++) {
      //   contentList.push(content[i]);
      // }
      // this.fengeList = contentList;
    },
  },
};
</script>

<style lang="less" scoped>
.index-box {
  position: relative;
  .card-list__itemone {
    width: 95vw;
    height: 30vh;
    margin: 5px 0 5px 0;
    margin-left: 2.5vw;
    .active-list__item-location {
      position: relative;
      top: -1px;
      left: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 6rem;
      height: 1.79rem;
      font-size: 0.99rem;
      color: #ffffff;
      border-top-left-radius: 10px;
      border-bottom-right-radius: 15px;
      background: #00706e;
      background-size: contain;
      z-index: 2;
    }
    .active-list__item-location-y {
      position: relative;
      top: -1px;
      left: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 6rem;
      height: 1.79rem;
      font-size: 0.99rem;
      color: #ffffff;
      border-top-left-radius: 10px;
      border-bottom-right-radius: 15px;
      background: #f79d27;
      background-size: contain;
      z-index: 2;
    }

    .headDiagram {
      height: 100%;
      width: 100%;
      z-index: 0;
      top: -1.79rem;
      position: relative;
      background-size: cover;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      // image-rendering: -webkit-optimize-contrast;
      border-radius: 15px;
    }
  }
  .card-list__title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-left: 2.5vw;
    width: 95vw;
    margin-top: 10px;
  }
  .card-list__titledetils {
    margin-top: 10px;
    margin-left: 2.5vw;
    width: 95vw;
    font-size: 0.9rem;
    color: #666666;
    line-height: 18px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .card-list__titledetils-content {
      display: flex;
      flex-direction: row;
      width: 95vw;
      margin-bottom: 5px;
    }
    .card-list__titledetils-content > div:first-of-type {
      width: 50%;
    }
  }
  .card_tail {
    display: flex;
    flex-direction: column;
    width: 95vw;
    margin-left: 2.5vw;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px; //行间距
    color: #747474;
    text-align: justify; //两端对齐
    margin-top: 10px;
    padding-bottom: 10px;
    .card_tail_content {
      padding: 0.5rem 1rem 0.5rem 1rem;
      line-height: 25px;
      margin-bottom: -2rem;
      // margin-top:-1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/DynamicDetails.vue